/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_LoadingInputs */

const en_us2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finding options…`)
};

const pt_br2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando opções…`)
};

const es_419_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando opciones…`)
};

const pt_pt2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A procurar opções…`)
};

const fr_fr2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche d'options…`)
};

const de_de2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen werden gesucht…`)
};

const it_it2_swap_loading = /** @type {(inputs: Swap_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerco le opzioni…`)
};

/**
* | output |
* | --- |
* | "Finding options…" |
*
* @param {Swap_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_loading = /** @type {((inputs?: Swap_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_loading(inputs)
	if (locale === "es-419") return es_419_swap_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_loading(inputs)
	if (locale === "de-DE") return de_de2_swap_loading(inputs)
	if (locale === "it-IT") return it_it2_swap_loading(inputs)
	return en_us2_swap_loading(inputs)
});
export { swap_loading as "swap.loading" }